module.exports = __webpack_public_path__ + "static/pinkballethamper-cb21d2156942cf05ee6fe9d5437bea2d.jpeg";